function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6151_1233)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1333 10C15.9676 10 15.8333 10.1343 15.8333 10.3V15.5333C15.8333 15.699 15.699 15.8333 15.5333 15.8333H4.46667C4.30098 15.8333 4.16667 15.699 4.16667 15.5333V10.3C4.16667 10.1343 4.03235 10 3.86667 10H2.8C2.63431 10 2.5 10.1343 2.5 10.3V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10.3C17.5 10.1343 17.3657 10 17.2 10H16.1333ZM10.8333 9.83605C10.8333 10.103 11.1559 10.237 11.3451 10.0486L12.7795 8.61965C12.8968 8.50288 13.0864 8.50306 13.2034 8.62006L13.9545 9.3712C14.0717 9.48836 14.0717 9.67831 13.9545 9.79546L10.2121 13.5379C10.095 13.655 9.90503 13.655 9.78787 13.5379L6.04547 9.79546C5.92831 9.67831 5.92831 9.48836 6.04547 9.3712L6.79661 8.62006C6.91361 8.50306 7.10324 8.50287 7.22046 8.61965L8.65494 10.0486C8.8441 10.237 9.16667 10.103 9.16667 9.83605V2.8C9.16667 2.63432 9.30098 2.5 9.46667 2.5H10.5333C10.699 2.5 10.8333 2.63431 10.8333 2.8V9.83605Z",
  fill: "#00C4B5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6151_1233"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.31d48e11.svg";
export { ForwardRef as ReactComponent };